<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark dense>
        <v-toolbar-title>프롬북 · API 테스터 (DEV)</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip small outlined dark class="mr-2">
          {{ totalApiCount }} APIs · {{ catalog.length }} 그룹
        </v-chip>
        <v-btn small outlined dark class="mr-2" @click="showSettings = !showSettings">
          <v-icon left small>mdi-cog</v-icon>Base URL/토큰
        </v-btn>
        <v-btn small outlined dark class="mr-2" @click="clearAllStorage" title="저장된 모든 payload/캡처 초기화">
          <v-icon left small>mdi-broom</v-icon>저장 초기화
        </v-btn>
        <v-btn small color="success" depressed class="mr-2" @click="exportDoc" :disabled="checkedCount === 0"
               title="체크된 API 를 요청/응답 포함 마크다운으로 export">
          <v-icon left small>mdi-file-export-outline</v-icon>문서 Export ({{ checkedCount }})
        </v-btn>
        <v-btn small color="amber darken-2" dark depressed @click="showUpload = !showUpload"
               title="피드 이미지 업로드 테스트 (multipart → URL)">
          <v-icon left small>mdi-image-plus</v-icon>이미지 업로드
        </v-btn>
      </v-toolbar>

      <!-- Base URL / Bearer 토큰 설정 (접힘) -->
      <v-expand-transition>
        <v-card v-if="showSettings" flat tile color="grey lighten-4">
          <v-card-text class="py-3">
            <v-row dense>
              <v-col cols="12" class="pb-0">
                <span class="text-caption grey--text mr-2">빠른 선택</span>
                <v-btn x-small outlined class="mr-1" @click="setBaseUrl('http://localhost:10005')">로컬</v-btn>
                <v-btn x-small outlined color="primary" class="mr-1" @click="setBaseUrl('https://prombookapidev.pnjstudio.com')">DEV (개발서버)</v-btn>
                <v-btn x-small outlined color="error" @click="setBaseUrl('https://prombookapi.snapplay.io')">LIVE</v-btn>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="serviceApiUrl"
                  label="Service_API_New Base URL"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-cloud-outline"
                  hint="예: http://localhost:10005 (로컬) / https://prombookapidev.pnjstudio.com (개발서버) / https://prombookapi.snapplay.io (라이브)"
                  persistent-hint
                  @blur="saveSettings"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="bearerToken"
                  label="Bearer Token (auth 필요 API 호출 시 자동 첨부)"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-key-variant"
                  hint="auth/login 응답의 access_token. 저장 시 localStorage 에 영구 보관 (DEV 전용)."
                  persistent-hint
                  clearable
                  @blur="saveSettings"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn small outlined @click="showSettings = false">닫기</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-expand-transition>

      <!-- 이미지 업로드 테스터 (multipart → /upload/image) -->
      <v-expand-transition>
        <v-card v-if="showUpload" flat tile color="amber lighten-5">
          <v-card-text class="py-3">
            <div class="text-subtitle-2 mb-2">
              <v-icon small left>mdi-image-plus</v-icon>피드 이미지 업로드
              <span class="text-caption grey--text ml-1">POST /s3_image_upload (multipart · file + USER_ID)</span>
            </div>
            <v-row dense align="center">
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="uploadUserId"
                  label="USER_ID"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-account"
                  hint="업로드 경로/썸네일 대상 유저"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="5">
                <v-file-input
                  v-model="uploadFiles"
                  label="이미지 선택 (여러 장 가능)"
                  accept="image/*"
                  multiple small-chips show-size
                  outlined dense hide-details prepend-icon="mdi-camera"
                ></v-file-input>
              </v-col>
              <v-col cols="12" sm="3">
                <v-btn small color="amber darken-2" dark depressed
                       :loading="uploading"
                       :disabled="!uploadUserId || !uploadFiles || uploadFiles.length === 0"
                       @click="doUpload">
                  <v-icon left small>mdi-cloud-upload</v-icon>업로드 ({{ (uploadFiles || []).length }}장)
                </v-btn>
                <v-btn v-if="uploadResults.length" small text class="ml-1"
                       @click="uploadResults = []; uploadedUrls = []">결과 비움</v-btn>
              </v-col>
            </v-row>

            <!-- 업로드 결과 -->
            <div v-if="uploadResults.length" class="mt-2">
              <div v-for="(r, i) in uploadResults" :key="i" class="text-caption d-flex align-center">
                <v-icon x-small :color="r.ok ? 'green' : 'red'" class="mr-1">
                  {{ r.ok ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                </v-icon>
                <span class="mr-2">{{ r.name }}</span>
                <code v-if="r.ok" style="font-size:11px">{{ r.url }}</code>
                <span v-else class="red--text">{{ r.error }}</span>
              </div>
            </div>

            <!-- 누적 URL → images 배열 -->
            <div v-if="uploadedUrls.length" class="mt-2">
              <div class="text-caption grey--text">feeds/create 의 <code>images</code> 에 넣을 배열 ({{ uploadedUrls.length }}개)</div>
              <pre style="margin:4px 0; padding:8px; background:#fff; border:1px solid #eee; font-size:11px; max-height:160px; overflow:auto">{{ uploadedUrlsJson }}</pre>
              <v-btn x-small outlined class="mr-1" @click="copyUploadedUrls"><v-icon left x-small>mdi-content-copy</v-icon>배열 복사</v-btn>
              <v-btn x-small color="primary" depressed @click="applyUrlsToFeedCreate"><v-icon left x-small>mdi-arrow-down-bold</v-icon>피드등록 images 에 적용</v-btn>
            </div>

            <div class="text-right mt-1">
              <v-btn small outlined @click="showUpload = false">닫기</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-expand-transition>

      <v-row no-gutters>
        <!-- 좌측: API 카탈로그 -->
        <v-col cols="12" md="4" class="pa-3 grey lighten-5" style="border-right:1px solid #eee; min-height:600px">
          <v-text-field
            v-model="keyword"
            label="API 검색"
            outlined dense hide-details clearable
            prepend-inner-icon="mdi-magnify"
            class="mb-3"
          ></v-text-field>

          <div class="mb-2 d-flex align-center flex-wrap">
            <v-btn x-small outlined @click="expandAll" class="mr-1 mb-1">
              <v-icon left x-small>mdi-chevron-double-down</v-icon>펼침
            </v-btn>
            <v-btn x-small outlined @click="collapseAll" class="mr-1 mb-1">
              <v-icon left x-small>mdi-chevron-double-up</v-icon>접기
            </v-btn>
            <v-btn x-small outlined color="primary" @click="checkAll" class="mr-1 mb-1">
              <v-icon left x-small>mdi-checkbox-multiple-marked-outline</v-icon>전체 체크
            </v-btn>
            <v-btn x-small text @click="uncheckAll" class="mb-1">해제</v-btn>
          </div>
          <v-list dense>
            <v-list-group
              v-for="g in filteredCatalog"
              :key="g.group"
              v-model="groupOpen[g.group]"
              :prepend-icon="groupIcon(g.group)"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ g.group }}
                    <span class="grey--text text-caption ml-1">({{ g.apis.length }})</span>
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="a in g.apis"
                :key="g.group + ':' + a.name"
                @click="selectApi(a)"
                :class="{ 'primary lighten-5': selected && selected.name === a.name }"
                class="pl-4"
              >
                <v-list-item-icon class="mr-2 my-2" @click.stop>
                  <v-simple-checkbox
                    :value="!!checked[a.name]"
                    color="primary"
                    :ripple="false"
                    @input="toggleCheck(a.name)"
                  ></v-simple-checkbox>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    <v-icon v-if="a.auth && !bearerToken" x-small color="grey lighten-1">mdi-lock</v-icon>
                    {{ a.label }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption">
                    <code style="font-size:11px">{{ a.endpoint }}</code>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="captured[a.name]">
                  <v-icon small :color="(captured[a.name].status && captured[a.name].status < 400) ? 'green' : 'orange'"
                          :title="'응답 캡처됨 (HTTP ' + captured[a.name].status + ')'">mdi-check-circle</v-icon>
                </v-list-item-action>
                <v-list-item-action v-else-if="hasSavedPayload(a.name)">
                  <v-icon small color="grey lighten-1">mdi-content-save-check-outline</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-col>

        <!-- 우측: payload 편집 + 호출 + 응답 -->
        <v-col cols="12" md="8" class="pa-4">
          <div v-if="!selected" class="text-center py-12 grey--text">
            <v-icon size="64" color="grey lighten-1">mdi-flask-empty-outline</v-icon>
            <p class="mt-3">좌측에서 호출할 API 를 선택하세요.</p>
          </div>

          <div v-else>
            <!-- 헤더 -->
            <v-card outlined class="mb-3">
              <v-card-text class="pb-2">
                <div class="d-flex align-center">
                  <div>
                    <div class="text-h6">
                      {{ selected.label }}
                      <v-icon v-if="selected.auth" small color="orange" class="ml-1" title="Bearer 토큰 필요">mdi-key</v-icon>
                    </div>
                    <div class="text-caption grey--text">
                      [{{ selectedGroup }}] {{ selected.name }}
                    </div>
                    <div class="text-caption mt-1">
                      <code>POST</code> <code>{{ effectiveUrl }}</code>
                    </div>
                    <div v-if="selected.auth && !bearerToken" class="text-caption red--text mt-1">
                      <v-icon x-small color="red">mdi-lock</v-icon>
                      로그인 필요 — 먼저 <b>로그인</b> API 를 호출해 토큰을 받으세요
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn small outlined color="grey" class="mr-2" @click="resetToDefault">
                    <v-icon left small>mdi-restore</v-icon>기본값 복원
                  </v-btn>
                  <v-btn small color="success" depressed class="mr-2" @click="savePayloadLocal">
                    <v-icon left small>mdi-content-save</v-icon>로컬 저장
                  </v-btn>
                  <v-btn small color="primary" depressed :loading="calling" :disabled="!canCallSelected" @click="callApi">
                    <v-icon left small>mdi-send</v-icon>호출
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>

            <!-- payload 편집 -->
            <v-card outlined class="mb-3">
              <v-card-title class="text-subtitle-2 grey lighten-4 pa-2">
                <v-icon left small>mdi-code-json</v-icon>
                Payload (JSON)
                <v-spacer></v-spacer>
                <span class="text-caption grey--text" v-if="payloadValid">
                  <v-icon x-small color="green">mdi-check-circle</v-icon> 유효
                </span>
                <span class="text-caption red--text" v-else>
                  <v-icon x-small color="red">mdi-alert-circle</v-icon> JSON 파싱 오류
                </span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-0">
                <v-textarea
                  v-model="payloadText"
                  solo flat hide-details
                  rows="14"
                  auto-grow
                  no-resize
                  style="font-family:monospace; font-size:13px"
                  @input="validatePayload"
                ></v-textarea>
              </v-card-text>
            </v-card>

            <!-- 응답 -->
            <v-card outlined>
              <v-card-title class="text-subtitle-2 grey lighten-4 pa-2">
                <v-icon left small>mdi-import</v-icon>
                응답
                <v-spacer></v-spacer>
                <span v-if="responseStatus !== null" class="text-caption">
                  HTTP <v-chip x-small :color="responseStatus < 400 ? 'green' : 'red'" dark class="ml-1">
                    {{ responseStatus }}
                  </v-chip>
                  <span class="ml-2 grey--text">{{ responseTime }}ms</span>
                </span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-0">
                <pre v-if="responseText" style="margin:0; padding:12px; background:#f5f5f5; font-size:12px; max-height:400px; overflow:auto">{{ responseText }}</pre>
                <div v-else class="pa-6 text-center grey--text text-caption">
                  아직 호출하지 않았습니다.
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <div class="py-12"></div>
  </div>
</template>

<script>
import axios from 'axios'
import { SERVICE_API_PROMBOOK_CATALOG } from '../../api/service_api_prombook_catalog'

const LS_PREFIX = 'prombook_cms:api_tester'

// Service_API base URL 기본값
//   - 로컬(내 PC)에서 CMS 를 띄운 경우 → 프롬북 로컬 API(localhost:10005)
//   - 그 외(개발서버 등에서 띄운 CMS) → 기존 개발서버 유지 (건드리지 않음)
const LOCAL_SA_URL = 'http://localhost:10005'
const DEV_SA_URL = 'https://prombookapidev.pnjstudio.com'
function isLocalHost() {
  const h = (typeof window !== 'undefined' && window.location && window.location.hostname) || ''
  return h === 'localhost' || h === '127.0.0.1' || h === '0.0.0.0'
}
function defaultServiceApiUrl() {
  return isLocalHost() ? LOCAL_SA_URL : DEV_SA_URL
}

// 테스트 불필요 그룹은 숨김 (Offerwall = 매체 postback 시그니처 전용, 수동 테스트 의미 없음)
const HIDDEN_GROUPS = ['Offerwall']
// 맨 위로 고정할 그룹 (Auth = 로그인 필수 → 항상 최상단)
const TOP_GROUPS = ['Auth']

// Service_API_New 만. 각 api 에 source 표시. 숨김 그룹 제외 + Auth 최상단 정렬.
function buildCatalog() {
  const groups = SERVICE_API_PROMBOOK_CATALOG
    .filter(g => !HIDDEN_GROUPS.some(h => g.group.startsWith(h)))
    .map(g => ({
      group: g.group,
      apis: g.apis.map(a => ({ ...a, source: 'service_api' })),
    }))
  // Auth 그룹을 맨 위로 (Array.sort 안정 정렬 → 나머지 그룹은 원래 순서 유지)
  groups.sort((a, b) => {
    const pa = TOP_GROUPS.some(t => a.group.startsWith(t)) ? 0 : 1
    const pb = TOP_GROUPS.some(t => b.group.startsWith(t)) ? 0 : 1
    return pa - pb
  })
  return groups
}

export default {
  name: 'Prombook_ApiTester',
  data() {
    return {
      catalog: buildCatalog(),
      keyword: '',
      selected: null,
      selectedGroup: '',
      payloadText: '',
      payloadValid: true,
      calling: false,
      responseText: '',
      responseStatus: null,
      responseTime: 0,
      groupOpen: {},                  // 그룹별 펼침 상태
      captured: {},                   // { [apiName]: { request, status, time, response, at } } — 호출 시 자동 캡처
      checked: {},                    // { [apiName]: true } — 문서 export 에 포함할 API
      // Service_API_New base URL + Bearer 토큰
      serviceApiUrl: defaultServiceApiUrl(),   // 로컬 CMS = localhost:10005 / 그 외 = 개발서버
      bearerToken: '',
      showSettings: false,
      // 이미지 업로드 테스터
      showUpload: false,
      uploadUserId: 'TEST_USER',   // /s3_image_upload 는 USER_ID(body) 로 경로/썸네일 대상 지정
      uploadFiles: [],
      uploading: false,
      uploadResults: [],   // [{ name, ok, url?, error? }]
      uploadedUrls: [],    // 업로드 성공 URL 누적
    }
  },
  computed: {
    totalApiCount() {
      return this.catalog.reduce((s, g) => s + g.apis.length, 0)
    },
    checkedCount() {
      return Object.keys(this.checked).filter(k => this.checked[k]).length
    },
    loggedIn() {
      return !!this.bearerToken
    },
    // auth 필요 API 는 토큰(로그인) 없으면 호출 불가
    canCallSelected() {
      if (!this.selected) return false
      return !(this.selected.auth && !this.bearerToken)
    },
    uploadedUrlsJson() {
      return JSON.stringify(this.uploadedUrls, null, 2)
    },
    effectiveUrl() {
      if (!this.selected) return ''
      return (this.serviceApiUrl || '').replace(/\/$/, '') + this.selected.endpoint
    },
    filteredCatalog() {
      const k = (this.keyword || '').trim().toLowerCase()
      if (!k) return this.catalog
      return this.catalog
        .map(g => ({
          group: g.group,
          apis: g.apis.filter(a =>
            a.name.toLowerCase().includes(k) ||
            a.label.toLowerCase().includes(k) ||
            a.endpoint.toLowerCase().includes(k)
          ),
        }))
        .filter(g => g.apis.length > 0)
    },
  },
  methods: {
    storageKey(apiName) { return `${LS_PREFIX}:payload:${apiName}` },
    expandAll() {
      this.catalog.forEach(g => this.$set(this.groupOpen, g.group, true))
    },
    collapseAll() {
      this.catalog.forEach(g => this.$set(this.groupOpen, g.group, false))
    },
    groupIcon(groupName) {
      const map = {
        'Auth (공용)':               'mdi-login-variant',
        'Prompts · 리스트':          'mdi-format-list-bulleted',
        'Prompts':                   'mdi-lightbulb-on-outline',
        'Feeds':                     'mdi-newspaper-variant-multiple-outline',
        'Comments':                  'mdi-comment-multiple-outline',
        'Notifications':             'mdi-bell-outline',
        'User · 차단':               'mdi-account-cancel-outline',
        '계정/유저정보 (공용)':      'mdi-account-details-outline',
        '유저데이터 (공용)':         'mdi-database-outline',
        'Mail (공용)':               'mdi-email-outline',
        '상점/구매 (공용)':          'mdi-cart-outline',
        'MultipleFetchData':         'mdi-layers-triple-outline',
        'Offerwall (pub · 시그니처 필요)': 'mdi-gift-outline',
      }
      return map[groupName] || 'mdi-folder-outline'
    },
    hasSavedPayload(apiName) {
      try { return !!localStorage.getItem(this.storageKey(apiName)) } catch (e) { return false }
    },
    selectApi(api) {
      this.selected = api
      // group 찾기 + 해당 그룹 자동 펼침
      const g = this.catalog.find(g => g.apis.some(a => a.name === api.name))
      this.selectedGroup = g ? g.group : ''
      if (g) this.$set(this.groupOpen, g.group, true)
      // 저장된 payload 우선, 없으면 defaults
      let payload
      try {
        const saved = localStorage.getItem(this.storageKey(api.name))
        if (saved) payload = JSON.parse(saved)
      } catch (e) { /* ignore */ }
      if (!payload) payload = api.defaults || {}
      this.payloadText = JSON.stringify(payload, null, 2)
      this.payloadValid = true
      // 이전에 캡처한 응답이 있으면 복원 (없으면 비움)
      const cap = this.captured[api.name]
      this.responseText = cap ? cap.response : ''
      this.responseStatus = cap ? cap.status : null
      this.responseTime = cap ? cap.time : 0
      try { localStorage.setItem(`${LS_PREFIX}:last_api`, api.name) } catch (e) { /* ignore */ }
    },
    resetToDefault() {
      if (!this.selected) return
      this.payloadText = JSON.stringify(this.selected.defaults || {}, null, 2)
      this.validatePayload()
    },
    validatePayload() {
      try {
        JSON.parse(this.payloadText)
        this.payloadValid = true
      } catch (e) {
        this.payloadValid = false
      }
    },
    savePayloadLocal() {
      if (!this.selected) return
      try {
        const obj = JSON.parse(this.payloadText)
        localStorage.setItem(this.storageKey(this.selected.name), JSON.stringify(obj))
        this.$nextTick(() => this.$forceUpdate())
        alert('로컬에 저장되었습니다. 다음 진입 시 자동 복원됩니다.')
      } catch (e) {
        alert('JSON 파싱 오류 — 저장 실패')
      }
    },
    setBaseUrl(url) {
      this.serviceApiUrl = url
      this.saveSettings()
    },
    saveSettings() {
      try {
        localStorage.setItem(`${LS_PREFIX}:service_api_url`, this.serviceApiUrl || '')
        localStorage.setItem(`${LS_PREFIX}:bearer_token`,    this.bearerToken   || '')
      } catch (e) { /* ignore */ }
    },
    loadSettings() {
      try {
        const s = localStorage.getItem(`${LS_PREFIX}:service_api_url`)
        const b = localStorage.getItem(`${LS_PREFIX}:bearer_token`)
        if (s) this.serviceApiUrl = s
        if (b) this.bearerToken   = b
        // 로컬 환경에서는 개발서버 URL 이 저장돼 있어도(또는 비어있어도) 로컬 API(10005)로 강제.
        // 개발서버에서 띄운 CMS 는 isLocalHost() 가 false 라 영향 없음.
        if (isLocalHost() && (!this.serviceApiUrl || this.serviceApiUrl.indexOf('prombookapidev.pnjstudio.com') !== -1)) {
          this.serviceApiUrl = LOCAL_SA_URL
        }
      } catch (e) { /* ignore */ }
    },
    clearAllStorage() {
      if (!confirm('저장된 모든 API payload 를 삭제하시겠습니까?')) return
      try {
        const keys = []
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i)
          if (k && k.startsWith(LS_PREFIX)) keys.push(k)
        }
        keys.forEach(k => localStorage.removeItem(k))
        this.captured = {}
        this.checked = {}
        this.$forceUpdate()
        alert(`${keys.length}개 항목 삭제됨`)
      } catch (e) {
        alert('초기화 실패: ' + e.message)
      }
    },
    // ── 체크 (문서 export 대상) ──
    toggleCheck(name) {
      this.$set(this.checked, name, !this.checked[name])
      this.persistChecked()
    },
    checkAll() {
      this.catalog.forEach(g => g.apis.forEach(a => this.$set(this.checked, a.name, true)))
      this.persistChecked()
    },
    uncheckAll() {
      this.checked = {}
      this.persistChecked()
    },
    persistChecked() {
      try { localStorage.setItem(`${LS_PREFIX}:checked`, JSON.stringify(this.checked)) } catch (e) { /* ignore */ }
    },
    // ── 응답 캡처 (호출 시 자동) ──
    captureResponse() {
      if (!this.selected) return
      this.$set(this.captured, this.selected.name, {
        request: this.payloadText,
        status: this.responseStatus,
        time: this.responseTime,
        response: this.responseText,
        at: new Date().toISOString(),
      })
      try { localStorage.setItem(`${LS_PREFIX}:captured`, JSON.stringify(this.captured)) } catch (e) { /* ignore */ }
      // 호출했으면 export 대상으로 자동 체크
      if (!this.checked[this.selected.name]) {
        this.$set(this.checked, this.selected.name, true)
        this.persistChecked()
      }
    },
    // ── 마크다운 문서 export (체크된 API 의 요청/응답) ──
    tsForFile() {
      const d = new Date(); const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}`
    },
    exportDoc() {
      const out = []
      out.push('# 프롬북 API 테스트 결과', '')
      out.push(`- Base URL: \`${this.serviceApiUrl}\``)
      out.push(`- 생성: ${new Date().toLocaleString()}`)
      out.push(`- 포함 API: ${this.checkedCount}개`, '')
      let n = 0
      for (const g of this.catalog) {
        const picked = g.apis.filter(a => this.checked[a.name])
        if (!picked.length) continue
        out.push(`## ${g.group}`, '')
        for (const a of picked) {
          n += 1
          const cap = this.captured[a.name]
          out.push(`### ${a.label} \`${a.name}\``, '')
          out.push(`\`POST\` \`${a.endpoint}\` · auth: ${a.auth ? '필요' : '불필요'}`, '')
          out.push('**Request**', '```json', cap ? cap.request : JSON.stringify(a.defaults || {}, null, 2), '```', '')
          if (cap) {
            out.push(`**Response** (HTTP ${cap.status}, ${cap.time}ms)`, '```json', cap.response, '```', '')
          } else {
            out.push('**Response** — _아직 호출 안 함_', '')
          }
        }
      }
      if (!n) { alert('체크된 API 가 없습니다.'); return }
      const blob = new Blob([out.join('\n')], { type: 'text/markdown;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const el = document.createElement('a')
      el.href = url
      el.download = `prombook_api_test_${this.tsForFile()}.md`
      document.body.appendChild(el); el.click(); document.body.removeChild(el)
      URL.revokeObjectURL(url)
    },
    // ── 이미지 업로드 (multipart → /upload/image) ──
    async doUpload() {
      const files = Array.from(this.uploadFiles || [])
      if (!files.length) return
      if (!this.uploadUserId) { alert('USER_ID 를 입력하세요.'); return }
      this.uploading = true
      const base = (this.serviceApiUrl || '').replace(/\/$/, '')
      const url = base + '/s3_image_upload'
      for (const file of files) {
        const fd = new FormData()
        fd.append('file', file)
        fd.append('USER_ID', this.uploadUserId)
        fd.append('DIR_PATH', 'prombook')
        try {
          const headers = {}
          if (this.bearerToken) headers.Authorization = 'Bearer ' + this.bearerToken
          const res = await axios.post(url, fd, { headers })
          const rd = res.data && res.data.res_data
          const u = (rd && (rd.fileUrl || rd.url)) || (res.data && res.data.url)
          if (u) {
            this.uploadResults.push({ name: file.name, ok: true, url: u })
            this.uploadedUrls.push(u)
          } else {
            this.uploadResults.push({ name: file.name, ok: false, error: '응답에 url 없음: ' + JSON.stringify(res.data) })
          }
        } catch (e) {
          const body = e.response && e.response.data
          const status = e.response && e.response.status ? 'HTTP ' + e.response.status + ' ' : ''
          this.uploadResults.push({ name: file.name, ok: false, error: status + (body ? JSON.stringify(body) : (e.message || e)) })
        }
      }
      this.uploading = false
      this.uploadFiles = []
    },
    copyUploadedUrls() {
      const text = this.uploadedUrlsJson
      try {
        navigator.clipboard.writeText(text)
        alert('복사됨')
      } catch (e) {
        const ta = document.createElement('textarea')
        ta.value = text; document.body.appendChild(ta); ta.select()
        try { document.execCommand('copy'); alert('복사됨') } catch (e2) { alert('복사 실패 — 직접 선택해 복사하세요') }
        document.body.removeChild(ta)
      }
    },
    applyUrlsToFeedCreate() {
      // sa_feeds_create 선택 + payload 의 images 를 누적 URL 로 채움
      let api = null
      for (const g of this.catalog) {
        const found = g.apis.find(a => a.name === 'sa_feeds_create')
        if (found) { api = found; break }
      }
      if (!api) { alert('feeds/create API 를 찾을 수 없습니다.'); return }
      this.selectApi(api)
      let payload = {}
      try { payload = JSON.parse(this.payloadText) } catch (e) { payload = { ...(api.defaults || {}) } }
      payload.images = this.uploadedUrls.slice()
      this.payloadText = JSON.stringify(payload, null, 2)
      this.validatePayload()
      this.showUpload = false
      alert(`feeds/create 의 images 에 ${this.uploadedUrls.length}개 URL 적용됨`)
    },
    async callApi() {
      if (!this.selected) return
      let payload
      try {
        payload = JSON.parse(this.payloadText)
      } catch (e) {
        alert('JSON 파싱 오류 — payload 를 확인하세요.')
        return
      }
      this.calling = true
      this.responseText = ''
      this.responseStatus = null
      const t0 = Date.now()
      try {
        const url = this.effectiveUrl
        const headers = {}
        if (this.selected.auth && this.bearerToken) {
          headers.Authorization = 'Bearer ' + this.bearerToken
        }
        const res = await axios.post(url, payload, { headers })
        this.responseStatus = res.status
        this.responseText = JSON.stringify(res.data, null, 2)
        // auth/login 응답이면 토큰 자동 캡처
        if (this.selected.name === 'sa_auth_login') {
          const t = res.data && (res.data.res_data?.access_token || res.data.access_token)
          if (t) { this.bearerToken = t; this.saveSettings(); }
        }
      } catch (e) {
        this.responseStatus = (e.response && e.response.status) || 0
        const body = e.response && e.response.data
        this.responseText = body
          ? JSON.stringify(body, null, 2)
          : `Error: ${e.message || e}`
      } finally {
        this.responseTime = Date.now() - t0
        this.calling = false
        this.captureResponse()   // 요청/응답 캡처 + export 대상 자동 체크
      }
    },
  },
  watch: {
    // 그룹 펼침 상태 변경 시 localStorage 저장
    groupOpen: {
      deep: true,
      handler(v) {
        try { localStorage.setItem(`${LS_PREFIX}:group_open`, JSON.stringify(v)) } catch (e) { /* ignore */ }
      },
    },
  },
  mounted() {
    // base URL + bearer 토큰 복원
    this.loadSettings()
    // 캡처 응답 + 체크 상태 복원
    try {
      const cap = localStorage.getItem(`${LS_PREFIX}:captured`)
      if (cap) { const p = JSON.parse(cap); if (p && typeof p === 'object') this.captured = p }
      const chk = localStorage.getItem(`${LS_PREFIX}:checked`)
      if (chk) { const p = JSON.parse(chk); if (p && typeof p === 'object') this.checked = p }
    } catch (e) { /* ignore */ }
    // 그룹 펼침 상태 복원 (없으면 모두 접힘)
    try {
      const saved = localStorage.getItem(`${LS_PREFIX}:group_open`)
      if (saved) {
        const parsed = JSON.parse(saved)
        if (parsed && typeof parsed === 'object') this.groupOpen = parsed
      }
    } catch (e) { /* ignore */ }
    // Auth(로그인) 그룹은 항상 펼쳐 노출 (로그인 우선 흐름)
    const authG = this.catalog.find(g => g.group.startsWith('Auth'))
    if (authG) this.$set(this.groupOpen, authG.group, true)
    // 마지막 선택 API 복원
    try {
      const lastName = localStorage.getItem(`${LS_PREFIX}:last_api`)
      if (lastName) {
        for (const g of this.catalog) {
          const a = g.apis.find(x => x.name === lastName)
          if (a) { this.selectApi(a); return }
        }
      }
    } catch (e) { /* ignore */ }
  },
}
</script>
